<mat-icon matTooltip="Options" [matMenuTriggerFor]="menu" style="font-size: 25px; color: black; cursor: pointer">
  more_vert
</mat-icon>

<mat-menu #menu="matMenu">
  <div *ngFor="let menuItem of menuItems">
    <button
      *ngIf="menuItem.type === 'button'"
      matTooltip="{{ menuItem.toolTip }}"
      mat-menu-item
      (click)="itemClicked(menuItem.item, false)"
    >
      <mat-icon>{{ menuItem.icon }}</mat-icon>
      <span>{{ menuItem.text }}</span>
    </button>

    <button
      *ngIf="menuItem.type === 'checkbox'"
      matTooltip="{{ menuItem.toolTip }}"
      (click)="itemClicked(menuItem.item, checked)"
      mat-menu-item
    >
      <mat-icon>{{ menuItem.icon }}</mat-icon>
      <mat-checkbox style="position: relative; top: 3px" [checked]="checked">
        <span>{{ menuItem.text }}</span>
      </mat-checkbox>
    </button>
  </div>
</mat-menu>
